import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import AttendanceChart from "../../src/pages/Dashboard/attendanceChart.jsx";
import Attendance from "./Dashboard/Attendance.jsx";
import { _getDropdownListData } from "../service";
import { Box, Card, Grid, MenuItem, Select, Typography, Avatar, Table, TableBody, TableCell, TableHead, TableRow, Button, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import {
  config,
  dashboardAPI,
  manageCompaniesAPI,
  manageInvoiceAPI,
  labourWagesAPI,
  leaveAPI,
  hrMasterListAPI,
} from "../config";
import moment from "moment";
import { startOfMonth, endOfMonth, format } from "date-fns";
import axios from "axios";

// Material Icons
import PeopleIcon from "@mui/icons-material/People";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ReceiptIcon from "@mui/icons-material/Receipt";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import EventNoteIcon from "@mui/icons-material/EventNote";

function Dashboard() {
  const navigate = useNavigate();
  const [totalList, settotalList] = useState({});
  const [type, setType] = useState("Today");

  const [fromDate, setfromDate] = useState(
    moment().utcOffset("+05:30").format("YYYY-MM-DD")
  );
  const [toDate, settoDate] = useState(
    moment().utcOffset("+05:30").format("YYYY-MM-DD")
  );

  const [companyList, setComanyList] = useState([]);
  const [companyID, setCompanyID] = useState(0);

  const [paymentRequestList, setPaymentRequestList] = useState([]);

  // Dashboard metrics states
  const [invoiceList, setInvoiceList] = useState([]);
  const [totalInvoiceValue, setTotalInvoiceValue] = useState(0);
  const [invoiceCount, setInvoiceCount] = useState(0);
  const [labourList, setLabourList] = useState([]);
  const [attendanceRate, setAttendanceRate] = useState(0);
  const [leaveRequests, setLeaveRequests] = useState([]);

  // HR metrics states
  const [onboardings, setOnboardings] = useState([]);
  const [departmentChartOptions, setDepartmentChartOptions] = useState({});
  const [departmentChartSeries, setDepartmentChartSeries] = useState([]);
  const [statusChartOptions, setStatusChartOptions] = useState({});
  const [statusChartSeries, setStatusChartSeries] = useState([]);

  useEffect(() => {
    let fromDate1 = moment().utcOffset("+05:30").format("YYYY-MM-DD"),
      toDate1 = moment().utcOffset("+05:30").format("YYYY-MM-DD");

    setfromDate(moment().utcOffset("+05:30").format("YYYY-MM-DD"));
    settoDate(moment().utcOffset("+05:30").format("YYYY-MM-DD"));

    if (type === "Month") {
      const currentDate = new Date();
      setfromDate(format(startOfMonth(currentDate), "yyyy-MM-dd"));
      settoDate(format(endOfMonth(currentDate), "yyyy-MM-dd"));

      fromDate1 = format(startOfMonth(currentDate), "yyyy-MM-dd");
      toDate1 = format(endOfMonth(currentDate), "yyyy-MM-dd");
    } else if (type === "This Week") {
      const currentDate = moment();
      fromDate1 = currentDate.clone().startOf("week").format("YYYY-MM-DD");
      toDate1 = currentDate.clone().endOf("week").format("YYYY-MM-DD");
      setfromDate(fromDate1);
      settoDate(toDate1);
    } else if (type === "Last Week") {
      const currentDate = moment();
      fromDate1 = currentDate.clone().subtract(1, "weeks").startOf("week").format("YYYY-MM-DD");
      toDate1 = currentDate.clone().subtract(1, "weeks").endOf("week").format("YYYY-MM-DD");
      setfromDate(fromDate1);
      settoDate(toDate1);
    } else if (type === "This Year") {
      const currentDate = moment();
      fromDate1 = currentDate.clone().startOf("year").format("YYYY-MM-DD");
      toDate1 = currentDate.clone().endOf("year").format("YYYY-MM-DD");
      setfromDate(fromDate1);
      settoDate(toDate1);
    }

    let requestData = {
      intType: 3,
      intID: companyID,
    };

    config.method = "POST";
    config.data = JSON.stringify(requestData);
    config.url = dashboardAPI;
    axios(config)
      .then(function (response) {
        settotalList(response.data.result[0] || {});
      })
      .catch(function (error) {
        console.log(error);
      });

    requestData = {
      intType: 1,
      intStatus: 57,
      txtFromDate: fromDate1,
      txtToDate: toDate1,
      intID: companyID,
    };
    config.method = "POST";
    config.data = JSON.stringify(requestData);
    config.url = dashboardAPI;
    axios(config)
      .then(function (response) {
        setPaymentRequestList(response.data.result || []);
      })
      .catch(function (error) {
        console.log(error);
      });

    // Fetch Daily Attendance rate percentage
    let attendanceReq = {
      intType: 4,
    };
    config.method = "POST";
    config.data = JSON.stringify(attendanceReq);
    config.url = dashboardAPI;
    axios(config)
      .then(function (res) {
        if (res.data.result && res.data.result.length > 0) {
          setAttendanceRate(parseFloat(res.data.result[0].logged_in_percentage || 0).toFixed(1));
        }
      })
      .catch(function (err) {
        console.log(err);
      });

    // Fetch Invoices metrics
    let invoiceReq = {
      intType: 16,
      intLimit: 1000,
      intOffset: 0,
    };
    config.method = "POST";
    config.data = JSON.stringify(invoiceReq);
    config.url = manageInvoiceAPI;
    axios(config)
      .then(function (res) {
        const list = res.data.data || [];
        setInvoiceList(list);
        const totalVal = list.reduce((sum, item) => sum + parseFloat(item.total_with_gst || 0), 0);
        setTotalInvoiceValue(totalVal);
        setInvoiceCount(list.length);
      })
      .catch(function (err) {
        console.log(err);
      });

    // Fetch all employees for HR metrics and charts
    let hrReq = {
      pageIndex: 0,
      pageSize: 1000,
      filters: [],
      sorting: [],
    };
    config.method = "POST";
    config.data = JSON.stringify(hrReq);
    config.url = hrMasterListAPI;
    axios(config)
      .then(function (res) {
        const list = res.data.result || [];

        // Recent onboarding list
        const sortedOnboardings = [...list]
          .filter(e => e.date_of_join && e.date_of_join !== "0000-00-00")
          .sort((a, b) => new Date(b.date_of_join) - new Date(a.date_of_join))
          .slice(0, 5);
        setOnboardings(sortedOnboardings);

        // Department breakdown
        const activeEmps = list.filter(e => e.reason_for_relieve !== 'Relieved' && e.reason_for_relieve !== 'Terminated');
        const deptsMap = {};
        activeEmps.forEach(emp => {
          const dept = emp.department_name || "Other";
          deptsMap[dept] = (deptsMap[dept] || 0) + 1;
        });

        const deptLabels = Object.keys(deptsMap);
        const deptValues = Object.values(deptsMap);

        setDepartmentChartSeries(deptValues);
        setDepartmentChartOptions({
          chart: { type: "pie", height: 380 },
          labels: deptLabels,
          legend: { position: "bottom" },
          title: { text: "Active Staff by Department", align: "left", style: { fontSize: "15px", fontWeight: "bold", color: "#1e293b" } },
          colors: ["#2196f3", "#4caf50", "#ff9800", "#9c27b0", "#009688", "#f44336", "#3f51b5", "#e91e63", "#00bcd4", "#ffeb3b", "#795548", "#607d8b"]
        });

        // Status breakdown
        let active = 0, relieved = 0, terminated = 0;
        list.forEach(emp => {
          if (emp.reason_for_relieve === 'Relieved') relieved++;
          else if (emp.reason_for_relieve === 'Terminated') terminated++;
          else active++;
        });

        setStatusChartSeries([active, relieved, terminated]);
        setStatusChartOptions({
          chart: { type: "donut", height: 380 },
          labels: ["Active", "Relieved", "Terminated"],
          legend: { position: "bottom" },
          title: { text: "Employee Status Distribution", align: "left", style: { fontSize: "15px", fontWeight: "bold", color: "#1e293b" } },
          colors: ["#4caf50", "#ff9800", "#f44336"]
        });
      })
      .catch(function (err) {
        console.log(err);
      });

    // Fetch Labourers list (up to 500 to sort Top/Bottom)
    let labourReq = {
      intLimit: 500,
      intOffset: 0,
      intType: 2,
    };
    config.method = "POST";
    config.data = JSON.stringify(labourReq);
    config.url = labourWagesAPI;
    axios(config)
      .then(function (res) {
        setLabourList(res.data.result || []);
      })
      .catch(function (err) {
        console.log(err);
      });

    // Fetch Leave approval request queue
    let leaveReq = {
      pageSize: 5,
      pageIndex: 0,
      intType: 8,
      columnFilters: [],
      sorting: [],
    };
    config.method = "POST";
    config.data = JSON.stringify(leaveReq);
    axios(config)
      .then(function (res) {
        const pending = (res.data.result || []).filter(item => item.leave_status === 84);
        setLeaveRequests(pending);
      })
      .catch(function (err) {
        console.log(err);
      });

  }, [type, companyID]);

  const handleChange = (event) => {
    setType(event.target.value);
  };

  //Get company Names
  useEffect(() => {
    let data = {
      requestData: {
        intType: 6,
      },
      API: manageCompaniesAPI,
      setData: setComanyList,
    };
    _getDropdownListData(data);
  }, []);

  // Compute Top 5 and Bottom 5 labourers dynamically
  const topLabourList = [...labourList]
    .sort((a, b) => parseFloat(b.full_day_amount || 0) - parseFloat(a.full_day_amount || 0))
    .slice(0, 5);

  const bottomLabourList = [...labourList]
    .sort((a, b) => parseFloat(a.full_day_amount || 0) - parseFloat(b.full_day_amount || 0))
    .slice(0, 5);

  return (
    <Layout>
      <Box sx={{ pt: 10, px: 3, pb: 4, backgroundColor: "#f4f6f9", minHeight: "100vh" }}>
        {/* Filters Sticky Header bar */}
        <Box
          sx={{
            padding: "16px 24px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            borderRadius: "8px",
            marginBottom: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px"
          }}
        >
          <Box>
            <Typography variant="h5" fontWeight={700} color="#0c53a0" sx={{ mb: 0.5 }}>
              Dashboard
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {fromDate === toDate
                ? moment(fromDate).format("DD MMMM YYYY")
                : moment(fromDate).format("DD MMMM YYYY") + " to " + moment(toDate).format("DD MMMM YYYY")}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            <Select
              size="small"
              value={companyID}
              onChange={(e) => {
                setCompanyID(e.target.value);
              }}
              sx={{
                minWidth: 180,
                borderRadius: "8px",
                backgroundColor: "#f8f9fa",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e9ecef" }
              }}
            >
              <MenuItem value={0}>All Companies</MenuItem>
              {companyList.map((row) => (
                <MenuItem value={row.id} key={row.id}>
                  {row.company_name}
                </MenuItem>
              ))}
            </Select>

            <Select
              size="small"
              value={type}
              onChange={handleChange}
              sx={{
                minWidth: 140,
                borderRadius: "8px",
                backgroundColor: "#f8f9fa",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e9ecef" }
              }}
            >
              <MenuItem value="Today">Today</MenuItem>
              <MenuItem value="This Week">This Week</MenuItem>
              <MenuItem value="Last Week">Last Week</MenuItem>
              <MenuItem value="Month">Current Month</MenuItem>
              <MenuItem value="Last Month">Last Month</MenuItem>
              <MenuItem value="This Year">This Year</MenuItem>
            </Select>
          </Box>
        </Box>

        {/* Stats Cards Grid - 5 columns layout */}
        <Grid container spacing={3} sx={{ marginBottom: "24px" }}>
          {/* Active Employees */}
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Card
              onClick={() => navigate("/employee/list")}
              sx={{
                p: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                borderLeft: "5px solid #2196f3",
                cursor: "pointer",
                transition: "all 0.25s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(33, 150, 243, 0.15)"
                }
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="body2" color="text.secondary" fontWeight={600}>Active Staff</Typography>
                  <Typography variant="h4" fontWeight={700} sx={{ mt: 1 }}>{totalList.active_users || 0}</Typography>
                </Box>
                <Avatar sx={{ bgcolor: "rgba(33, 150, 243, 0.1)", color: "#2196f3", width: 48, height: 48 }}>
                  <PeopleIcon />
                </Avatar>
              </Box>
              <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
                <Typography variant="caption" color="text.secondary">Total active users</Typography>
              </Box>
            </Card>
          </Grid>

          {/* Attendance Rate */}
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Card
              onClick={() => navigate("/employee-attendance")}
              sx={{
                p: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                borderLeft: "5px solid #4caf50",
                cursor: "pointer",
                transition: "all 0.25s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(76, 175, 80, 0.15)"
                }
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="body2" color="text.secondary" fontWeight={600}>Attendance Rate</Typography>
                  <Typography variant="h4" fontWeight={700} sx={{ mt: 1 }}>{attendanceRate || 0}%</Typography>
                </Box>
                <Avatar sx={{ bgcolor: "rgba(76, 175, 80, 0.1)", color: "#4caf50", width: 48, height: 48 }}>
                  <CheckCircleIcon />
                </Avatar>
              </Box>
              <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
                <Typography variant="caption" color="text.secondary">Today's log-in percent</Typography>
              </Box>
            </Card>
          </Grid>

          {/* Active Projects */}
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Card
              onClick={() => navigate("/project/list")}
              sx={{
                p: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                borderLeft: "5px solid #ff9800",
                cursor: "pointer",
                transition: "all 0.25s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(255, 152, 0, 0.15)"
                }
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="body2" color="text.secondary" fontWeight={600}>Active Projects</Typography>
                  <Typography variant="h4" fontWeight={700} sx={{ mt: 1 }}>{totalList.active_projects || 0}</Typography>
                </Box>
                <Avatar sx={{ bgcolor: "rgba(255, 152, 0, 0.1)", color: "#ff9800", width: 48, height: 48 }}>
                  <BusinessCenterIcon />
                </Avatar>
              </Box>
              <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
                <Typography variant="caption" color="text.secondary">Projects in progress</Typography>
              </Box>
            </Card>
          </Grid>

          {/* Total Invoiced Value */}
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Card
              onClick={() => navigate("/invoice/list")}
              sx={{
                p: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                borderLeft: "5px solid #9c27b0",
                cursor: "pointer",
                transition: "all 0.25s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(156, 39, 176, 0.15)"
                }
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="body2" color="text.secondary" fontWeight={600}>Total Invoiced</Typography>
                  <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }}>
                    ₹{(totalInvoiceValue / 100000).toFixed(2)} L
                  </Typography>
                </Box>
                <Avatar sx={{ bgcolor: "rgba(156, 39, 176, 0.1)", color: "#9c27b0", width: 48, height: 48 }}>
                  <MonetizationOnIcon />
                </Avatar>
              </Box>
              <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
                <Typography variant="caption" color="text.secondary">Total master invoice sums</Typography>
              </Box>
            </Card>
          </Grid>

          {/* Active Invoices Count */}
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Card
              onClick={() => navigate("/invoice/list")}
              sx={{
                p: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                borderLeft: "5px solid #009688",
                cursor: "pointer",
                transition: "all 0.25s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(0, 150, 136, 0.15)"
                }
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="body2" color="text.secondary" fontWeight={600}>Invoice Count</Typography>
                  <Typography variant="h4" fontWeight={700} sx={{ mt: 1 }}>{invoiceCount || 0}</Typography>
                </Box>
                <Avatar sx={{ bgcolor: "rgba(0, 150, 136, 0.1)", color: "#009688", width: 48, height: 48 }}>
                  <ReceiptIcon />
                </Avatar>
              </Box>
              <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
                <Typography variant="caption" color="text.secondary">Generated invoice forms</Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>

        {/* Unified Full-Width Layout Grid */}
        <Grid container spacing={3}>
          {/* Row 1: Attendance Charts */}
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", height: 420, display: "flex", flexDirection: "column" }}>
              <Typography variant="h6" fontWeight={700} sx={{ mb: 2, color: "#1e293b" }}>
                Daily Attendance
              </Typography>
              <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <AttendanceChart />
              </Box>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", height: 420, display: "flex", flexDirection: "column" }}>
              <Typography variant="h6" fontWeight={700} sx={{ mb: 2, color: "#1e293b" }}>
                Payment Requests Status ({type})
              </Typography>
              <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Attendance
                  fromDate={fromDate}
                  toDate={toDate}
                  type={type}
                  companyID={companyID}
                />
              </Box>
            </Card>
          </Grid>

          {/* Row 2: HR Analytics Charts (Full Width Span - Interactive click to Employee List) */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                p: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                height: 480,
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                {departmentChartSeries.length > 0 ? (
                  <ReactApexChart
                    options={departmentChartOptions}
                    series={departmentChartSeries}
                    type="pie"
                    height={400}
                    style={{ width: "100%" }}
                  />
                ) : (
                  <Typography align="center" color="text.secondary">No department records</Typography>
                )}
              </Box>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card
              sx={{
                p: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                height: 480,
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                {statusChartSeries.length > 0 ? (
                  <ReactApexChart
                    options={statusChartOptions}
                    series={statusChartSeries}
                    type="donut"
                    height={400}
                    style={{ width: "100%" }}
                  />
                ) : (
                  <Typography align="center" color="text.secondary">No status records</Typography>
                )}
              </Box>
            </Card>
          </Grid>

          {/* Row 3: Recent Invoices Table */}
          <Grid item xs={12}>
            <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)" }}>
              <Typography variant="h6" fontWeight={700} sx={{ mb: 2, color: "#1e293b" }}>
                Recent Invoices
              </Typography>
              <Box sx={{ overflowX: "auto" }}>
                {invoiceList.length > 0 ? (
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#f8f9fa" }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Invoice No.</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Client Name</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Company</TableCell>
                        <TableCell sx={{ fontWeight: 600 }} align="right">Amount (incl. GST)</TableCell>
                        <TableCell sx={{ fontWeight: 600 }} align="center">Due Date</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoiceList.slice(0, 5).map((row) => (
                        <TableRow key={row.id} hover>
                          <TableCell sx={{ color: "#0c53a0", fontWeight: "bold" }}>
                            {row.invoice_no}
                          </TableCell>
                          <TableCell>{row.client_name}</TableCell>
                          <TableCell>{row.company_name}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold" }}>
                            ₹{parseFloat(row.total_with_gst || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                          </TableCell>
                          <TableCell align="center">{row.due_date ? moment(row.due_date).format("DD/MM/YYYY") : "-"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography align="center" color="text.secondary" sx={{ py: 4 }}>No invoices found</Typography>
                )}
              </Box>
            </Card>
          </Grid>

          {/* Row 4: Recent Onboardings Table */}
          <Grid item xs={12}>
            <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)" }}>
              <Typography variant="h6" fontWeight={700} sx={{ mb: 2, color: "#1e293b" }}>
                Recent Employee Onboardings
              </Typography>
              <Box sx={{ overflowX: "auto" }}>
                {onboardings.length > 0 ? (
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#f8f9fa" }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Emp No.</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Employee Name</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Position</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Department</TableCell>
                        <TableCell sx={{ fontWeight: 600 }} align="center">Join Date</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {onboardings.map((row) => (
                        <TableRow key={row.ID} hover>
                          <TableCell sx={{ color: "#0c53a0", fontWeight: "bold" }}>
                            {row.employee_no}
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>{row.employee_name}</TableCell>
                          <TableCell>{row.position_name || "-"}</TableCell>
                          <TableCell>{row.department_name || "-"}</TableCell>
                          <TableCell align="center">{row.date_of_join ? moment(row.date_of_join).format("DD/MM/YYYY") : "-"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography align="center" color="text.secondary" sx={{ py: 4 }}>No recent onboardings found</Typography>
                )}
              </Box>
            </Card>
          </Grid>

          {/* Row 5: Relocated widgets (4 items side-by-side) */}
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", minHeight: 320 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2, width: "100%" }}>
                <Box display="flex" alignItems="center" gap={1.5}>
                  <Avatar sx={{ bgcolor: "rgba(224, 242, 241, 1)", color: "#00796b", width: 36, height: 36 }}>
                    <EventNoteIcon fontSize="small" />
                  </Avatar>
                  <Typography variant="h6" fontWeight={700} sx={{ color: "#1e293b" }}>
                    Leave Approval
                  </Typography>
                </Box>
                <Button
                  size="small"
                  onClick={() => navigate("/Leave/approval")}
                  sx={{ textTransform: "none", fontSize: "0.75rem", fontWeight: "bold" }}
                >
                  Show More
                </Button>
              </Box>
              <Box>
                {leaveRequests.length > 0 ? (
                  <Box display="flex" flexDirection="column" gap={2}>
                    {leaveRequests.slice(0, 3).map((item, idx) => {
                      const fromDate = moment(item.leave_from_date);
                      const toDate = moment(item.leave_to_date);
                      const days = toDate.isValid() && fromDate.isValid() ? toDate.diff(fromDate, "days") + 1 : 0;
                      return (
                        <Box
                          key={idx}
                          sx={{
                            p: 1.5,
                            borderRadius: "8px",
                            backgroundColor: "#fafafa",
                            borderLeft: "4px solid #00796b",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
                          }}
                        >
                          <Box display="flex" justifyContent="space-between" sx={{ mb: 0.5 }}>
                            <Typography variant="subtitle2" fontWeight={700} color="#2d3748">
                              {item.employee_name}
                            </Typography>
                            <Chip
                              label={`${days} Day(s)`}
                              size="small"
                              sx={{ height: 20, fontSize: "0.75rem", bgcolor: "#e0f2f1", color: "#00796b", fontWeight: 600 }}
                            />
                          </Box>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontSize: "0.8rem" }}>
                            Type: <strong>{item.leave_subject || "Casual Leave"}</strong> | Range: {fromDate.isValid() ? fromDate.format("DD MMM") : ""} - {toDate.isValid() ? toDate.format("DD MMM") : ""}
                          </Typography>
                          <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                maxWidth: "60%"
                              }}
                            >
                              {item.leave_reason || "No reason specified"}
                            </Typography>
                            <Button
                              size="small"
                              variant="outlined"
                              color="primary"
                              onClick={() => navigate("/Leave/approval")}
                              sx={{ textTransform: "none", fontSize: "0.75rem", py: 0.2 }}
                            >
                              Review
                            </Button>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                ) : (
                  <Typography align="center" color="text.secondary" sx={{ py: 4 }}>No pending leaves</Typography>
                )}
              </Box>
            </Card>
          </Grid>
 
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", minHeight: 320 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2, width: "100%" }}>
                <Typography variant="h6" fontWeight={700} sx={{ color: "#1e293b" }}>
                  Labour wage (Top 5)
                </Typography>
                <Button
                  size="small"
                  onClick={() => navigate("/config/labour-wages")}
                  sx={{ textTransform: "none", fontSize: "0.75rem", fontWeight: "bold" }}
                >
                  Show More
                </Button>
              </Box>
              <Box>
                {topLabourList.length > 0 ? (
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#f8f9fa" }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, px: 1 }}>Name</TableCell>
                        <TableCell sx={{ fontWeight: 600, px: 1 }}>Type</TableCell>
                        <TableCell sx={{ fontWeight: 600, px: 1 }} align="right">Wage</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {topLabourList.map((row) => (
                        <TableRow key={row.id} hover>
                          <TableCell sx={{ fontWeight: "bold", px: 1 }}>{row.labour_name}</TableCell>
                          <TableCell sx={{ px: 1 }}>{row.status_name || "NMR"}</TableCell>
                          <TableCell align="right" sx={{ color: "#2e7d32", fontWeight: "bold", px: 1 }}>
                            ₹{parseFloat(row.full_day_amount || 0).toLocaleString("en-IN")}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography align="center" color="text.secondary" sx={{ py: 4 }}>No labourers found</Typography>
                )}
              </Box>
            </Card>
          </Grid>
 
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", minHeight: 320 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2, width: "100%" }}>
                <Typography variant="h6" fontWeight={700} sx={{ color: "#1e293b" }}>
                  Labour wage (Bottom 5)
                </Typography>
                <Button
                  size="small"
                  onClick={() => navigate("/config/labour-wages")}
                  sx={{ textTransform: "none", fontSize: "0.75rem", fontWeight: "bold" }}
                >
                  Show More
                </Button>
              </Box>
              <Box>
                {bottomLabourList.length > 0 ? (
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#f8f9fa" }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, px: 1 }}>Name</TableCell>
                        <TableCell sx={{ fontWeight: 600, px: 1 }}>Type</TableCell>
                        <TableCell sx={{ fontWeight: 600, px: 1 }} align="right">Wage</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bottomLabourList.map((row) => (
                        <TableRow key={row.id} hover>
                          <TableCell sx={{ fontWeight: "bold", px: 1 }}>{row.labour_name}</TableCell>
                          <TableCell sx={{ px: 1 }}>{row.status_name || "NMR"}</TableCell>
                          <TableCell align="right" sx={{ color: "#c62828", fontWeight: "bold", px: 1 }}>
                            ₹{parseFloat(row.full_day_amount || 0).toLocaleString("en-IN")}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography align="center" color="text.secondary" sx={{ py: 4 }}>No labourers found</Typography>
                )}
              </Box>
            </Card>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", minHeight: 320 }}>
              <Typography variant="h6" fontWeight={700} sx={{ mb: 2, color: "#1e293b" }}>
                Payment Requests ({type})
              </Typography>
              <Box>
                {paymentRequestList.length > 0 ? (
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#f8f9fa" }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, px: 1 }}>Project</TableCell>
                        <TableCell sx={{ fontWeight: 600, px: 1 }} align="right">Paid</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paymentRequestList.slice(0, 5).map((row, idx) => (
                        <TableRow key={idx} hover>
                          <TableCell sx={{ px: 1 }}>{row.project_name}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold", color: "#10b981", px: 1 }}>
                            {row.formatted_amount}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography align="center" color="text.secondary" sx={{ py: 4 }}>No records found</Typography>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}

export default Dashboard;
